import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "utils/axios";

const AdminMain = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [accountCount, setAccoutCount] = useState<number>(0);
  const [reviewCount, setReviewCount] = useState<number>(0);
  const [resourceCount, setResourceCount] = useState<number>(0);
  const [adCount, setAdCount] = useState<number>(0);
  const [cityCount, setCityCount] = useState<number>(0);
  const [clickCount, setClickCount] = useState<number>(0);
  const [topOrgs, setTopOrgs] = useState<Array<string>>([]);
  const [topSearchTerms, setTopSearchTerms] = useState<Array<string>>([]);
  useEffect(() => {
    loadDetailInfo();
  }, []);

  const loadDetailInfo = async () => {
    let result = await axios.get("/api/review/count");
    setReviewCount(result.data.count);
    result = await axios.get("/api/resource/count");
    setResourceCount(result.data.count);
    result = await axios.get("/api/resource/cityCount");
    setCityCount(result.data.count);
    result = await axios.get("/api/ad/count");
    setAdCount(result.data.count);
    result = await axios.get("/api/ad/getClickCount");
    setClickCount(result.data.count[0].totalClick || 0);
    result = await axios.get("/api/resource/topOrgs");
    let array = [];
    for (let item of result.data) {
      array.push(item.organization);
    }
    setTopOrgs(array);
    result = await axios.get("/api/search/topSearchTerms");
    array = [];
    for (let item of result.data) {
      array.push(item.keyword);
    }
    setTopSearchTerms(array);
    result = await axios.post("/api/contract/getAllNFTCount", {
      contractId: process.env.REACT_APP_CONTRACT_ID,
    });
    setAccoutCount(result.data.length);
    setLoading(false);
  };
  return (
    <>
      {loading ? (
        <p>Please wait while loading details...</p>
      ) : (
        <>
          <div className="bg-[#EDEDED] flex flex-wrap sm:-mx-[6px] md:-mx-6">
            <div className="w-1/3 flex flex-col items-center justify-center text-center text-5xl text-main font-bold sm:w-1/2 h-[150px]">
              {accountCount > 1000
                ? `${Math.trunc(accountCount / 1000)}K`
                : accountCount}
              <br />
              <p>Accounts</p>
            </div>
            <div className="w-1/3 flex flex-col items-center justify-center text-center text-5xl text-main font-bold sm:w-1/2 h-[150px]">
              {reviewCount > 1000
                ? `${Math.trunc(reviewCount / 1000)}K`
                : reviewCount}
              <br />
              <p>Total Reviews</p>
            </div>
            <div className="w-1/3 flex flex-col items-center justify-center text-center text-5xl text-main font-bold sm:w-1/2 h-[150px]">
              {resourceCount > 1000
                ? `${Math.trunc(resourceCount / 1000)}K`
                : resourceCount}
              <br />
              <p>Total Resources</p>
            </div>
            <div className="w-1/3 flex flex-col items-center justify-center text-center text-5xl text-main font-bold sm:w-1/2 h-[150px]">
              {adCount > 1000 ? `${Math.trunc(adCount / 1000)}K` : adCount}
              <br />
              <p>Total Ads</p>
            </div>
            <div className="w-1/3 flex flex-col items-center justify-center text-center text-5xl text-main font-bold sm:w-1/2 h-[150px]">
              {cityCount > 1000
                ? `${Math.trunc(cityCount / 1000)}K`
                : cityCount}
              <br />
              <p>Total Cities</p>
            </div>
            <div className="w-1/3 flex flex-col items-center justify-center text-center text-5xl text-main font-bold sm:w-1/2 h-[150px]">
              {clickCount > 1000
                ? `${Math.trunc(clickCount / 1000)}K`
                : clickCount}
              <br />
              <p>Total Ad Clicks</p>
            </div>
          </div>
          <div className="sm:mx-auto">
            <div className="mt-[32px]">
              <h4>Top Orgs</h4>
              {topOrgs.map((org, index) => (
                <Link to={`/organization/${org}`} key={index}>
                  <span className="cursor-pointer text-lg font-opensans font-light">
                    {index + 1}. {org}
                    <br />
                  </span>
                </Link>
              ))}
            </div>
            <div className="mt-8">
              <h4>Top Search Terms</h4>
              {topSearchTerms.map((term, index) => (
                <p key={index} className="first-letter:uppercase">
                  {term}
                  <br />
                </p>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AdminMain;
